import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getOneDeliveryChallan = createAsyncThunk(
    "/prosafe/get-delivery-one-challan",
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/get-delivery-challan-details/${payload}`;

            const response = await axios({
                method: "get",
                url: myurl,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data);
            }
        } catch (error) {
            console.log(error, "error");
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const initialState = {
    user: null,
    loading: false,
    error: null,
};

const getOneDeliveryChallanSlice = createSlice({
    name: "getOneDeliveryChallan",
    initialState,
    reducers: {
        resetGetOneDeliveryChallan: (state) => {
            state.user = null;
            state.loading = false;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getOneDeliveryChallan.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getOneDeliveryChallan.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getOneDeliveryChallan.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const { resetGetOneDeliveryChallan } = getOneDeliveryChallanSlice.actions;

export default getOneDeliveryChallanSlice.reducer;
